var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50877 19.204V27.1684C7.50877 30.2777 10.0293 32.7982 13.1385 32.7982H25.81C28.9192 32.7982 31.4397 30.2777 31.4397 27.1684V19.0447L20.6185 23.1706C19.8112 23.4784 18.9192 23.481 18.1102 23.1777L7.50877 19.204Z",
    fill: "#FFC0AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7533 24.1365L33.7533 13.4934L36.2216 13.4934L36.2216 24.1365L33.7533 24.1365Z",
    fill: "#FFC0AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.33 6.06573C19.1373 5.7579 20.0293 5.75538 20.8383 6.05864L37.4557 12.2872C38.4757 12.6695 38.4797 14.1108 37.462 14.4989L20.6185 20.921C19.8112 21.2288 18.9192 21.2313 18.1102 20.9281L1.49282 14.6995C0.472868 14.3172 0.468792 12.8759 1.48657 12.4879L18.33 6.06573Z",
    fill: "#F46940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampusIcon);
export default __webpack_public_path__ + "static/media/campusIcon.5a759d331c86feb4a81be477777adc06.svg";
export { ForwardRef as ReactComponent };